// Vendor Libs
import React from 'react';
import {isEmpty} from 'lodash';

// Components
import Button from '../core/button';
import FormConfirm from '../core/form-confirm';
import Loading from '../core/loading';
import UserForm from './user-form';

// Containers
import FormContextProvider from '../../containers/form-context-provider';
import RequestPassword from '../../containers/request-password';
import useFormData from '../../hooks/use-form-data';

// Styles
import './edit-user.scss';

const formName = 'editUser';

function EditUser() {
    const {resetForm, searchFetching, searchValues = {}, searchValues: {clientId, email} = {}} = useFormData(formName);

    const getFormConfirmProps = (requestPassword) => {
        const {
            handleConfirmClick,
            handleResetClick,
            requestCompleted,
            resetRequestPassword,
            status: {error, fetching, response} = {},
        } = requestPassword;

        return {
            completed: requestCompleted,
            confirmMessage: 'Are you sure you want to request password reset?',
            confirmLabel: 'Submit',
            error,
            fetching,
            formSubmitReset: resetRequestPassword,
            onComplete: handleResetClick,
            onCancel: resetRequestPassword,
            onConfirm: handleConfirmClick,
            response,
            searchData: searchValues,
            whitelistKeys: ['clientId', 'name', 'email', 'active'],
        };
    };

    const getRequestPasswordProps = () => ({
        email,
        formName,
        recordId: clientId,
    });

    const renderRequestPasswordButton = (requestPassword) => {
        const {handleRequestPasswordClick, shouldRenderRequestPasswordButton} = requestPassword;

        return shouldRenderRequestPasswordButton() ? (
            <div className="edit-user--request-password-reset-button">
                <Button disabled={isEmpty(email)} onClick={handleRequestPasswordClick}>
                    Reset User Password
                </Button>
            </div>
        ) : null;
    };

    return (
        <div className="edit-user">
            <FormContextProvider formName={formName}>
                {clientId ? (
                    <RequestPassword {...getRequestPasswordProps()}>
                        {(requestPassword) => (
                            <>
                                {renderRequestPasswordButton(requestPassword)}
                                {requestPassword.shouldRenderConfirm() ? (
                                    <FormConfirm {...getFormConfirmProps(requestPassword)} />
                                ) : (
                                    <UserForm
                                        {...{
                                            className: 'edit-user',
                                            clientId,
                                            editing: true,
                                            formName,
                                            onReset: (submitted, resetValues) =>
                                                resetForm(submitted, resetValues, true),
                                        }}
                                    />
                                )}
                                <Loading loading={requestPassword.status.fetching} />
                            </>
                        )}
                    </RequestPassword>
                ) : (
                    <div className="edit-user--message">Select a user from the list</div>
                )}
                <Loading loading={searchFetching} />
            </FormContextProvider>
        </div>
    );
}

export default EditUser;
